import { Coins, Building2, Tractor, Landmark } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import StageSection from "./StageSection";

const GRANTS = [
  {
    icon: Landmark,
    name: "CDBG Entitlement",
    funder: "HUD",
    range: "$500K – $3M / year",
    fit: "Mall site sits in an eligible Prichard low/mod income block group — qualifies for slum & blight removal and economic development set-asides.",
    tag: "Block Grant",
  },
  {
    icon: Building2,
    name: "EDA Public Works",
    funder: "U.S. EDA",
    range: "$500K – $30M",
    fit: "Catalytic redevelopment of distressed commercial property with measurable job-creation targets — exactly EDA's brief.",
    tag: "Capital",
  },
  {
    icon: Tractor,
    name: "USDA Rural Business Dev.",
    funder: "USDA Rural Dev.",
    range: "$10K – $500K",
    fit: "Underwrite the incubator bays: equipment, training, and TA for Prichard-based small businesses.",
    tag: "Operating",
  },
];

const FundStage = () => {
  return (
    <StageSection
      id="fund"
      number="03"
      eyebrow="Fund · Opportunity"
      title="Match each initiative to the money already on the table."
      intro="The Financial Empowerment Action Plan names the goals; block grants, EDA awards, and USDA programs are the fuel — and they routinely go underused in priority zips. Our Opportunities hub keeps an updated, filterable view of what's open for the Prichard Plaza initiative and every one that follows."
      icon={Coins}
      ctaLabel="Find grants for your idea"
      ctaHref="/opportunities"
    >
      <div className="space-y-3">
        {GRANTS.map((g) => (
          <div
            key={g.name}
            className="rounded-2xl border border-border bg-card p-5 hover:border-primary/40 transition-all"
          >
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                <g.icon className="h-5 w-5 text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <h3 className="font-display font-semibold text-foreground">
                    {g.name}
                  </h3>
                  <Badge variant="outline" className="text-[10px]">
                    {g.tag}
                  </Badge>
                </div>
                <div className="text-xs text-muted-foreground mb-2">
                  {g.funder} · {g.range}
                </div>
                <p className="text-sm text-foreground/85 leading-relaxed">
                  <span className="font-semibold text-primary">Why it fits: </span>
                  {g.fit}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </StageSection>
  );
};

export default FundStage;